<template>
	<v-dialog
		v-model="display"
		width="400"
		origin="center center"
	>
		<v-card>
			<v-card-text class="text-center pt-4 pb-0 font-14">
				Jesteś pewien że chcesz usunąc komentarz?
			</v-card-text>
			<v-card-actions class="d-flex justify-center py-5">
				<v-btn
					@click="decision(false, null)"
				>
					Anuluj
				</v-btn>
				<v-btn
					v-if="author"
					@click="decision(true, 'author')"
					color="accent"
				>
					Usuń
					<template v-if="manager && author">
						jako autor
					</template>
				</v-btn>
				<v-btn
					v-if="manager"
					@click="decision(true, 'manager')"
					color="accent"
					:loading="saving"
				>
					Usuń
					<template v-if="manager && author">
						jako manager
					</template>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import {mapGetters} from "vuex";

export default {
	name: "PostCommentRemoveDialog",
	props: {
		visible: {
			type: Boolean,
			required: true
		},
		action: {
			type: Function,
			required: true
		},
		comment: {
			type: Object,
			required: true
		},
		saving: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		visible: function (v) {
			this.display = v
		}
	},
	data () {
		return {
			display: false,
			manager: false,
			author: false,
		}
	},
	computed: {
		...mapGetters({
			user: 'auth/user'
		}),
	},
	created() {
		this.manager = this.user.role && this.user.role.id === 2
		this.author = this.comment.user.id === this.user.id
	},
	methods: {
		async decision(remove, deleted_as) {
			await this.action(remove, deleted_as);
		},
		clickOutside() {
			this.$nextTick(function () {
				if (this.display)
					this.decision(false, null)
			})
		}
	}
}
</script>
